import { Grid, Typography } from '@mui/material';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { useStoreState } from 'pullstate';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BackdropLoader from '../../components/BackdropLoader.jsx';
import { AppStore } from '../../stores/AppStore.js';
import { getEmployees, getToken } from '../../utils/getData.js';
import SignInPage from './SignInPage.jsx';
import getConsentId from '../../utils/getConsentId.js'

const GoogleAuth = () => {

    const { user, loading } = useStoreState(AppStore);
    const navigate = useNavigate();
    const [clientId, setClientId] = useState(getConsentId())
    const [showManualLogin, setShowManualLogin] = useState(false);

    // function to handle prompt moment notifications
    const handlePromptNotification = useCallback((notification) => {
        if (notification.isSkippedMoment()) {
            setShowManualLogin(true);
        }
    }, []);

    const loginWithGoogle = useCallback(async (response) => {
        try {
            await getToken(response, navigate)
        } catch (e) {
            console.error('Error during token processing:', e);
            setShowManualLogin(true);
        }
    }, [navigate])

    const handleLoginError = useCallback((err) => {
        setShowManualLogin(true);
    }, []);

    const updatePullStateEmployees = async () => {
        try {
            await getEmployees()
        } catch (e) {
            console.error('Error', e)
        }
    }

    useEffect(() => {
        updatePullStateEmployees()
    }, [user])

    // If we need to show manual login, render the SignInPage component
    if (showManualLogin) {
        return <SignInPage />;
    }

    return (
        <GoogleOAuthProvider clientId={clientId}>
            <BackdropLoader openBackdrop={loading} />
            <Grid display={'none'} container justifyContent="center">
                <GoogleLogin
                    onSuccess={loginWithGoogle}
                    onError={handleLoginError}
                    promptMomentNotification={handlePromptNotification}
                    useOneTap
                    auto_select={true}
                // cookiePolicy={'single_host_origin'}
                />
            </Grid>
        </GoogleOAuthProvider>
    )
}

export default GoogleAuth